import * as Sentry from "@sentry/react";

const parseSampleRate = (value: string | undefined, fallback: number): number => {
  if (value === undefined || value === "") return fallback;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const initSentry = (): void => {
  const sentryTunnelUrl = import.meta.env.VITE_SENTRY_TUNNEL_URL || "/observability/sentry";
  const sentryDebug = import.meta.env.VITE_SENTRY_DEBUG === "true";
  const disableTunnel = import.meta.env.VITE_SENTRY_DISABLE_TUNNEL === "true";

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    enabled: true,
    debug: sentryDebug,
    ...(disableTunnel ? {} : { tunnel: sentryTunnelUrl }),
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: parseSampleRate(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE, 0),
    replaysSessionSampleRate: parseSampleRate(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE, 0),
    replaysOnErrorSampleRate: parseSampleRate(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE, 1),
  });
};

export const maybeRunSentrySmokeTest = (): void => {
  if (import.meta.env.VITE_SENTRY_SMOKE_TEST === "true") {
    Sentry.captureMessage("Sentry smoke test from frontend", "info");
  }
};
